import React from 'react'
import ReactHighcharts from 'react-highcharts'
import '../../../index.css'

export const LineChart = props => {

    const config = {
        tooltip: {
            valueDecimals: 2,
            xDateFormat: '%H:%M - %d/%m'

        },
        xAxis: {
            categories: props.xAxis,
            type: 'datetime',
            tickInterval: 24,
            labels: {
                format: '{value:%H:%M - %d/%m}',
                rotation: 0,
                style: {
                    color: '#f2f2f2'
                },
            }
        },
        yAxis: {
            title: {
                enabled: false
            },
            min: 0,
            max: 150,
            labels: {
                style: {
                    color: '#f2f2f2'
                }
            }
        },
        plotOptions: {
            spline: {
                marker: {
                    enabled: false,
                }
            }
        },
        series: [{
            name: "AQI",
            type: 'spline',
            zones: [
                {
                    value: 40,
                    color: 'rgb(121, 188, 106)'
                }, {
                    value: 60,
                    color: 'rgb(187, 207, 76)'
                }, {
                    value: 75,
                    color: 'rgb(238, 194, 11)'
                }, {
                    value: 95,
                    color: 'rgb(242, 147, 5)'
                }, {
                    value: 20000000,
                    color: 'rgb(244,67,54)'
                }],

            data: props.messages
        }],
        title: {
            floating: true,
            text: ""
        },
        chart: {
            height: 150,
            spacingBottom: 5,
            spacingTop: 10,
            spacingLeft: 5,
            spacingRight: 5,
            backgroundColor: " rgba(255, 255, 255, 0.0)"
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        }


    };

    return (
        <ReactHighcharts config={config}/>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/Common/LineChart.js